import connector from '../../connector.js'

/**
 * Get LaborPublisher version
 * @returns {Promise<string>} LaborPublisher version
 */
export function get () {
  return connector.get('version').json()
}
